<template>
  <div>
    <b-navbar type="dark" variant="dark" toggleable="md">
      <b-navbar-brand to="/admin">管理者介面</b-navbar-brand>
      <b-navbar-toggle target="admin-nav"></b-navbar-toggle>
      <b-collapse id="admin-nav" is-nav>
        <b-navbar-nav>
          <b-nav-item to="/admin/classify">分類管理</b-nav-item>

          <b-nav-item to="/admin/product">商品管理</b-nav-item>

          <b-nav-item-dropdown text="首頁管理">
            <b-dropdown-item to="/admin/homeset/ads">輪播廣告</b-dropdown-item>
            <b-dropdown-item to="/admin/homeset/favors">首頁推薦</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item to="/admin/users">會員管理</b-nav-item>

          <b-nav-item-dropdown text="訂單紀錄">
            <b-dropdown-item to="/admin/deliver" exact>訂單查詢</b-dropdown-item>
            <b-dropdown-item to="/admin/deliver/ctrl">取貨管理</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown text="統計分析">
            <b-dropdown-item to="/admin/statistics/production">商品統計</b-dropdown-item>
            <b-dropdown-item to="/admin/statistics/deliver">訂單統計</b-dropdown-item>
          </b-nav-item-dropdown>

          <b-nav-item-dropdown text="商城管理">
            <b-dropdown-item to="/admin/control/glob">商城設定</b-dropdown-item>
            <b-dropdown-item to="/admin/control/payment">金流設定</b-dropdown-item>
            <b-dropdown-item to="/admin/control/sub-admin">管理權限</b-dropdown-item>
            <b-dropdown-item to="/admin/control/records">操作歷程</b-dropdown-item>
          </b-nav-item-dropdown>
          <!-- Navbar dropdowns -->
        </b-navbar-nav>
        <b-navbar-nav class="ml-auto">
          <b-nav-item-dropdown right>
            <template v-slot:button-content>
              <em>管理員</em>
            </template>
            <b-dropdown-item to="/admin/panel">個人資料</b-dropdown-item>
            <b-dropdown-item @click="onClickLogout">登出</b-dropdown-item>
          </b-nav-item-dropdown>
        </b-navbar-nav>
      </b-collapse>
    </b-navbar>
    <b-container fluid>
      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>
    </b-container>
  </div>
</template>
<script>
export default {
  methods: {
    async onClickLogout () {
      await this.$api.logout()
      this.$router.push('/admin/login')
    }
  }
}
</script>
<style>
  body {
    font-family: 'Avenir', Helvetica, Arial, sans-serif, 'Open Sans', Arial, Helvetica, '微軟正黑體', 'Microsoft JhengHei', '新細明體', Verdana, sans-serif; 
  }
  .custom-header-border {
    border-left-color: rgba(0, 153, 204, 1) !important;
    border-left-width: 5px !important;
  }
  .custom-header-bg {
    background-color: rgba(226, 226, 226, 1) !important;
  }
</style>